import { rpc } from '…/app/common/rpc/client.mjs';


export function restoreMatches(engagementId: ObjectId) {
  return rpc
    .post('actions/restore-original-matches', {
      json: { engagementId },
    });
}
